<script setup lang="ts">
import HamburgerIcon from '@/assets/SideMenu/HamburgerIcon.svg'
import logoDark from '/logo-dark.svg'
import UserDropdown from './UserDropdown.vue'
// import MessagesDropdown from './MessagesDropdown.vue'
import LangSelector from './LangSelector.vue'
import { RouterLink } from 'vue-router'

const sidebarOpen = defineModel<boolean>('sidebarOpen', { default: false })
</script>

<template>
  <header id="header" class="header">
    <div class="header-controls">
      <div class="hamburger-container">
        <button class="hamburger-button" @click="sidebarOpen = !sidebarOpen">
          <HamburgerIcon />
        </button>
      </div>
    </div>
    <RouterLink custom to="/dashboard" v-slot="{ navigate }">
      <div class="logo-container" @click="navigate">
        <img :src="logoDark" alt="Logo" />
      </div>
    </RouterLink>
    <div class="right-bar">
      <!-- <MessagesDropdown teleport-target="#header" /> -->
      <UserDropdown teleport-target="#header" />
      <LangSelector teleport-target="#header" />
    </div>
  </header>
</template>

<style lang="scss" scoped>
.header {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: var(--ullib-size-header-height);
  background-color: var(--ullib-color-background);
  display: flex;
  align-items: center;
  z-index: 5;
  box-shadow: 0px 3px 6px #00000029;
}

.header-controls {
  height: 100%;
  display: flex;
  align-items: center;
}

.hamburger-container {
  height: 100%;
  display: flex;
  align-items: center;
  padding: 0 13px;
  // background-color: var(--ullib-color-primary);
}

.hamburger-button {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  background-color: transparent;
  border: none;
  transition: background-color 0.1s ease-in;
  &:hover {
    // background-color: var(--ullib-color-hamburger-hover);
  }
  background-color: var(--ullib-color-primary);
}

.logo-container {
  flex-shrink: 0;
  margin-left: 19px;
  height: 24px;
  display: flex;
  cursor: pointer;
}

.right-bar {
  width: 100%;
  margin-right: 16px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
</style>
